import React, { useState, useEffect, useRef, useCallback } from 'react'

import Grid from '@material-ui/core/Grid';
import ImputComponent from "../InputComponent"
import { LanguageFactory, LocalPersistence } from '../../factories';
import { useLanguage } from '../../store/languageContext'
import SearchDebounceBar from '../SearchDebounce';
import SearchIcon from '@material-ui/icons/Search';
import { PropertySearch } from '../../factories/propertySearchs';
import { Button, Card, Table, Tag } from 'antd';
import { getGuestroomsTable } from '../../services/guestrooms';
import Loading from '../Loading';
import styles from './components/index.module.css'
import { sortHelper } from '../../helpers/misc/sortHelper'
import { paginationSize, getPaginationSession } from '@helpers/misc/setPaginationSize'

interface propsTypes {
    isEditable?: void | any,
    cancelEditable?: void | any,
    setOperation?: void | any
    operationFlag?: any
    setCurrentRow?: void | any
    currentRow?: any
    setDefKey : (e: string) => void
    setSingleAmenity: (e: string) => void
    setDisableRoomAmenity: (e: boolean) => void
    defKey: string
}
const GuestRoomsTable = (props: propsTypes) => {
    const { language } = useLanguage()
    const lang = new LanguageFactory(language)
    const initialRender = useRef(true);
    const [searchs, setSearch] = useState<string[]>([]);
    const [tableLoading, setTableLoading] = useState(false);
    const [paginationData, setPaginationData] = useState<number>(10)
    const columns = [
        {
            title: '',
            key: 'index',
            // @ts-expect-error
            render: (text: string, record: [], index: number) => Number(record?.key) ? Number(record?.key) + 1 : index += 1,
            width: '40px'
        },
        {
            title: lang.translate(language, 'guestroom_list_column1'),
            dataIndex: 'id',
            key: 'id',
            ellipsis: {
                showTitle: false,
            },
            sorter: (a: [], b: []) => sortHelper(a, b, 'id'),
            showSorterTooltip: false
        },
        {
            title: lang.translate(language, 'guestroom_list_column2'),
            dataIndex: 'name',
            key: 'name',
            ellipsis: {
                showTitle: false,
            },
            sorter: (a: [], b: []) => sortHelper(a, b, 'name'),
            showSorterTooltip: false,
            onCell: () => {
                return {
                    onClick: (ev: any) => {
                        props.setOperation('view')
                        props.setDefKey('1')
                        props.setSingleAmenity(props.currentRow)
                    },
                };
            },
            render: (text: string) => (
                <>
                    <span style={{ color: '#06789D', cursor: 'pointer' }}>
                        {text}
                    </span>
                </>
            )
        },
        {
            title: lang.translate(language, 'guestroom_list_column3'),
            dataIndex: 'type',
            key: 'type',
            ellipsis: {
                showTitle: false,
            },
            sorter: (a: [], b: []) => sortHelper(a, b, 'type'),
            showSorterTooltip: false
        },
        {
            title: lang.translate(language, 'guestroom_list_column4'),
            dataIndex: 'maxoccupancy',
            key: 'maxoccupancy',
            ellipsis: {
                showTitle: false,
            },
            sorter: (a: [], b: []) => sortHelper(a, b, 'maxoccupancy'),
            showSorterTooltip: false
        },
        {
            title: lang.translate(language, 'guestroom_list_column5'),
            dataIndex: 'minoccupancy',
            key: 'minoccupancy',
            ellipsis: {
                showTitle: false,
            },
            sorter: (a: [], b: []) => sortHelper(a, b, 'minoccupancy'),
            showSorterTooltip: false
        },
        {
            title: lang.translate(language, 'guestroom_list_column6'),
            dataIndex: 'maxadults',
            key: 'maxadults',
            ellipsis: {
                showTitle: false,
            },
            sorter: (a: [], b: []) => sortHelper(a, b, 'maxadults'),
            showSorterTooltip: false
        }
    ]

    const [dataSource, setDataSource] = useState<object[]>([]);
    const [total, setTotal] = useState(dataSource.length);
    const [data, setData] = useState(dataSource);

    const onChangeSearch = (term: string) => {
        setSearchTerm(term)
        onDebounce(term)
    }
    const {
        searchTerm, setSearchTerm, searchTermDebounced, onDebounce
    } = SearchDebounceBar()

    const recentlySearchs = () => {
        return searchs.map((search, index) => {
            return (
                <span key={index} onClick={() => recoverSearch(search)}>
                    &nbsp;{search}{searchs.length - 1 === index ? '.' : ','}
                </span>
            )
        })
    }
    const recoverSearch = (search: string) => {
        setSearchTerm(search)
        filterData(search)
        onDebounce(search)
    }

    const saveNewSearch = (term: string) => {
        const stackSearchs = new PropertySearch(searchs)
        setSearch(stackSearchs.add(term))
    }
    const afterDebounce = (term: string) => {
        if (term) {
            saveNewSearch(term)
        }
        filterData(term)
    }
    const filterData = async (query: string) => {
        const filterData = data.filter((item: any) => {
            const newFilterData: any = {}
            columns.forEach((col: any) => {
                newFilterData[col['dataIndex']] = (item[col.dataIndex] == null || item[col.dataIndex] == undefined) ? '' : JSON.stringify(item[col.dataIndex]).toLowerCase();
            })
            return JSON.stringify(Object.values(newFilterData)).indexOf(query.toLowerCase()) > -1;
        })
        setDataSource(filterData);
    }
    useEffect(() => {
        const dataSourceLength = dataSource.length
        if(dataSourceLength > 0){
            props.setDisableRoomAmenity(false)
        }
        setTotal(dataSourceLength)
        
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps 
    [dataSource])
    //   search functionality
    useEffect(() => {
        if (initialRender.current) {
            initialRender.current = false;
        } else {
            afterDebounce(searchTermDebounced);
        }
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps 
    [searchTermDebounced])
    const getData = async () => {
        setTableLoading(true)
        const get_session = new LocalPersistence('session')
        const session: any = await get_session.getSessionPersistence();
        const resultData = await getGuestroomsTable(session.supplier, session.propertyId);
        await getPaginationData();
        setTableLoading(false)
        const resData = resultData && resultData.property && resultData.property.guestrooms.guestroom && resultData.property.guestrooms.guestroom.length !== 0 ? resultData.property.guestrooms.guestroom : []
        resData.forEach((item: any, index: any) => { item.key = '' + index; })
        setDataSource(resData)
        setData(resData)
    }

    useEffect(() => {
        getData();
        props.operationFlag === 'edit' || props.operationFlag === 'add' ? props.isEditable(true) : props.cancelEditable(false)
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps 
    [props.operationFlag])

    useEffect(() => {
        getData();
    },[props.defKey])

    const getPaginationData = useCallback(async () => {
        return await getPaginationSession(
            setPaginationData,
            'guest_rooms'
        );
    }, [])

    return (
        <div className={styles.tableContent}>
            { !tableLoading &&
                <Card>
                    <Grid container spacing={0} className="containerSpacing py-0">
                        <Grid item xs={12} className="p-0">
                            <div className={styles.guestRoomTitle}>
                                <div style={{ fontWeight: 'bold' }}>Guest Rooms</div>
                                <div>
                                    <Button 
                                        className="db-add-btn" 
                                        style={{ width: 88, height: 32 }} onClick={() => { 
                                            props.setOperation('add')
                                            props.setSingleAmenity('') 
                                        }}
                                    > Add </Button>
                                </div>
                            </div>
                        </Grid>
                        <Grid item xs={4} className="pb-0 px-0 my-0">
                            <ImputComponent
                                className='SearchBar'
                                //label={lang.translate(language, 'search')}
                                label={'Search'}
                                labelShrink={true}
                                value={searchTerm}
                                onChange={onChangeSearch}
                                placeholder={lang.translate(language, 'guestrooms_property_search_placeholder')}
                                endAdornment={<SearchIcon style={{ color: '#9a9a9a' }} />}
                            />
                            <div className="recentlySearchs">
                                <p>{lang.translate(language, 'recently_searched')}: {recentlySearchs()}</p>
                            </div>
                        </Grid>
                        <Grid item xs={12} className="p-0">
                            <Table
                                columns={columns}
                                // @ts-expect-error explanation: table error type as by defult antd is expecting an empty array
                                dataSource={dataSource}
                                onRow={record => {
                                    return {
                                        onClick: event => {
                                            props.setCurrentRow(record)
                                        },
                                    };
                                }}
                                pagination={{
                                    pageSizeOptions: ['10', '20', '50', '100'],
                                    showSizeChanger: true,
                                    showTotal: (total, range) => `Total ${total} items, current ${range[0]}-${range[1]}`,
                                    defaultPageSize: paginationData,
                                    onShowSizeChange: (current, size: number) => paginationSize('pagination', { 'guest_rooms': size }),
                                    size: "small",
                                    total,

                                    onChange: (page, pageSize) => {

                                    }
                                }}
                            />
                        </Grid>
                    </Grid>
                </Card>}
            { tableLoading && <Loading type={'large'} />}
        </div>

    )
}

export default GuestRoomsTable;

